export default __webpack_public_path__ + "static/media/xingxing.3323afd4.png";